<template>
    <div class="main-tabla-principal">
        <headerFIltros @openAdd="btnAddProdutc" @searchProduct="onFilter" />
        <div class="row g-0">
            <div class="col-12">
                <tableBody :prodServiceLists="ProdServiceLists" :filterProduct="inputFilter" @onEditProduct="editProduct" @onDeleteProduct="deleteProduct"/>
            </div>
        </div>
        <!-- modal -->
        <modalLateral>
            <component v-bind:is="m.component"></component>
        </modalLateral>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
// @ts-ignore
import Loader from '@/core/components/shared/Loader'
// @ts-ignore
import modalLateral from '@/core/plugins/themeModalLateral/modalLateral'
// @ts-ignore
import formProductServices from '@/apps/billing/components/setting/formProductServices'
import headerFIltros from './headerFIltros.vue';
import tableBody from './tableBody.vue';
export default {
    components: {
        Loader,
        modalLateral,
        formProductServices,
        headerFIltros,
        tableBody,
    },
    data() {
        return {
            inputFilter: '',
            isLoading: false,
            m: {
                show: false,
                component: '',
                data: []
            },
            FormAddPS: {
                btnName: "SAVE",
                Action: "Add",
                id: null,
                productname: null,
                account_id: 0,
                quantity: 1,
                unitcost: 1,
                cogs: '',
                description: null,
                applytax: 0,
                status: 0,
            },
            ProdServiceLists: [],
            NoRecord: false,
        };  
    },
    mounted() {
        this.getProdservices();
    },
    methods: {
        btnAddProdutc() {
            this.FormAddPS = {
                btnName: "SAVE",
                Action: "Add",
                id: null,
                productname: null,
                account_id: 0,
                quantity: 1,
                unitcost: null,
                cogs: '',
                description: null,
                applytax: 0,
                status: 1,
            }
            let t = this
            this.m = {
                show: true,
                component: 'formProductServices',
                data: {
                    "FormAddPS": t.FormAddPS
                }
            }
            this.$store.commit('core/setOpenModal', this.m);
        },
        getProdservices(load) {
            if (load == undefined) { this.isLoading = true; }
            window.billing
                .get("/productServicesById/" + window.localuserdata)
                .then((response) => {
                    console.log("product sevice list table ");
                    // console.log(response.data.result);
                    this.ProdServiceLists = response.data.result;
                    if (this.ProdServiceLists.length == 0) {
                        this.NoRecord = true;
                    }
                    this.isLoading = false;
                })
                .catch((error) => console.log(error));
        },
        onFilter(val) {
            this.inputFilter = val;
        },
        editProduct(item) {
            this.FormAddPS = {
                btnName: "UPDATE",
                Action: "Update",
                id: item.id,
                productname: item.productname,
                account_id: item.account_id,
                quantity: item.quantity,
                unitcost: item.unitcost,
                cogs: item.cogs,
                description: item.description,
                applytax: item.applytax,
                status: item.status,
            };
            let t = this
            console.log('edit product', this.FormAddPS);
            this.m = {
                show: true,
                component: 'formProductServices',
                data: { FormAddPS: t.FormAddPS }
            }
            this.$store.commit('core/setOpenModal', this.m);
        },
        deleteProduct(id) {
            console.log('delete Product', this.FormAddPS);
            this.isLoading = true;
            this.$swal({
                title: "Delete this Product?",
                text: "Are you sure?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
            }).then((result) => {
                if (result.value) {
                    window.billing
                    .put("product-services/" + id, {
                        user_id: window.localuserdata,
                    })
                    .then((response) => {
                        console.log(response.data);
                        this.isLoading = false;
                        if (response.data.deleted) {
                            this.getProdservices();
                            this.$swal.fire({
                                icon: "success",
                                title: "Deleted Product Successful",
                                showConfirmButton: false,
                                timer: 2000,
                            });
                        } else {
                            this.$swal.fire({
                                icon: "error",
                                title: "Error",
                                text:
                                    "It has invoice or estimate assigned to this product.",
                                showConfirmButton: false,
                                timer: 6000,
                            });
                        }
                    })
                    .catch((error) => console.log(error, (this.isLoading = false)));
                }
            });
            this.isLoading = false;
        },
    },
    computed: {
        ...mapGetters("core", {
            getOpenModal: "getOpenModal",
            getActionRefresh: "getActionRefresh",
        }),
    },
    watch: {
        'getActionRefresh': function () {
            if (Object.keys(this.getActionRefresh.data).length > 0) {
                let t = this.getActionRefresh.data;
                if (t.methods === 'refreshList') {
                    this.getProdservices(1);
                }
            }
        },
    }
};
</script>
<style scoped></style>
